import { useState } from 'react';
import { Loader2 } from 'lucide-react';

export function SeoReport() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="max-w-6xl mx-auto py-8">
      {/* Header */}
      <div className="mb-6">
        <p className="text-xs font-medium tracking-widest uppercase text-muted-foreground mb-2">
          SEO Strategy
        </p>
        <h1 className="text-2xl font-bold tracking-tight">
          SEO Strategy Dashboard
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Keyword strategy, competitor analysis, and implementation roadmap for The Wharf Fish &amp; Oyster Company
        </p>
      </div>

      {/* Iframe container */}
      <div className="relative rounded-lg border border-border/50 overflow-hidden bg-[#0a0a0a]" style={{ minHeight: '80vh' }}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-background/80 z-10">
            <div className="flex items-center gap-3 text-muted-foreground">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span className="text-sm">Loading SEO Dashboard...</span>
            </div>
          </div>
        )}
        <iframe
          src="/seo-dashboard.html"
          title="SEO Strategy Dashboard"
          className="w-full border-0"
          style={{ height: 'calc(100vh - 200px)', minHeight: '600px' }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
}
